import store from '@/store'
import { saveAs } from 'file-saver'
import JSZip, { files } from 'jszip'
import { ElMessage } from 'element-plus'
import { t } from '@/plugins/i18n'
import { useWaterMark, BlobData } from '@/util/useMark'
import { goodsProductDownloadImg } from '@/apis/goods'
interface F {
  files: string[]
  fold: string
}
export const saveImgs = async function (name: string, arr: F[], mark = false): Promise<void> {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    store.commit('status/loading', true)
    const zip = new JSZip()
    const canvas = document.createElement('canvas')
    const len = arr.reduce((len, v) => len + v.files.length, 0)
    let hasError: any = 0
    await Promise.all(
      arr.map(({ fold, files }) => {
        const folder = zip.folder(fold)
        if (!folder) return
        return Promise.all(
          files.map((url, i) => {
            const reg = /.(png|jpg|jpeg|bmp|webp)/
            const type = (url.match(reg) || [''])[1]
            // 是否需要水印导出
            // let extralUrl=url.includes('.vvic.com')?'/goods/product/download/img'
            return !mark ? getImgData(url, canvas).then((res) => {
              if (res && res.blob && type) {
                folder.file(i + 1 + '.' + type, res.blob, { binary: true })
              } else {
                console.log('errorURL', url)
                hasError += 1
              }
            }) : useWaterMark(url).then((res: BlobData) => {
              if (res && type && res.blob) {
                folder.file(i + 1 + '.png', res.blob, { binary: true })
              } else {
                console.log('errorURL', url)
                hasError += 1
              }
            })
          })
        )
      })
    )
    if (len === hasError) {
      store.commit('status/loading', false)
      ElMessage.error(t('该商品无法下载商品图'))
      return
    }
    const content = await zip.generateAsync({ type: 'blob' })
    const fileName = `${name}.zip`
    store.commit('status/loading', false)
    if (hasError) {
      ElMessage.warning(t('部分图片读取失败，请按需手动下载，正在开启自动下载'))
    } else {
      ElMessage.success(t('商品图下载成功'))
    }
    resolve()
    saveAs(content, fileName)
  })
}

export const download = (url:any, filename:any) => {
  return fetch(url).then(res => res.blob()).then(res => {
    const href = URL.createObjectURL(res)
    const a = document.createElement('a')
    a.href = href
    a.download = filename
    a.click()
    a.remove()
  })
}

interface Data {
  blob: Blob | null
}
export const getImgData = (
  url: string,
  canvas: HTMLCanvasElement
): Promise<Data | void> => {
  return new Promise((resolve) => {
    if (url.includes('.vvic.com')) {
      goodsProductDownloadImg(url).then((res) => {
        resolve({ blob: res })
      }).catch(() => {
        resolve()
      })
    } else {
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.src = url
      img.onload = function () {
        const { height, width } = img
        canvas.height = height
        canvas.width = width
        const ctx = canvas.getContext('2d')
        ctx && ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob((blob) => {
          resolve({ blob })
        })
      }
      img.onerror = () => {
        resolve()
      }
    }

    //
  })
}
